import PropTypes from 'prop-types';
import Link01Icon from '@untitled-ui/icons-react/build/esm/Link01';
import Trash02Icon from '@untitled-ui/icons-react/build/esm/Trash02';
import Edit02 from '@untitled-ui/icons-react/build/esm/Edit02';
import { Menu, MenuItem, menuItemClasses, SvgIcon } from '@mui/material';
import { useNavigate } from 'react-router';
import { paths } from 'src/paths';
import { useCallback } from 'react';

export const ItemMenu = (props) => {
  const { anchorEl, onClose, onDelete, open = false, data={} } = props;
  const navigate = useNavigate();
  const editHandler = useCallback( () => {
    navigate(`/calculators/${data.id}/details`)
  }, [data])
  return (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'right',
        vertical: 'bottom'
      }}
      onClose={onClose}
      open={open}
      sx={{
        [`& .${menuItemClasses.root}`]: {
          fontSize: 14,
          '& svg': {
            mr: 1
          }
        }
      }}
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top'
      }}
    >
      <MenuItem onClick={editHandler}>
      <SvgIcon fontSize="small">
          <Edit02 />
        </SvgIcon>
        Edit
        
      </MenuItem>
      {/* <MenuItem onClick={onClose}>
        <SvgIcon fontSize="small">
          <Link01Icon />
        </SvgIcon>
        Copy Link
      </MenuItem>
      <MenuItem
        onClick={onDelete}
        sx={{ color: 'error.main' }}
      >
        <SvgIcon fontSize="small">
          <Trash02Icon />
        </SvgIcon>
        Delete
      </MenuItem> */}
    </Menu>
  );
};

ItemMenu.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  open: PropTypes.bool
};
